export function getTranslate() {
	try {
		const injector = angular.element(document.querySelector("[ng-app]")).injector();
		return injector.get("$translate");
	} catch (e) {
		console.warn("❗ AngularJS not ready, translation unavailable.");
		return { instant: (k) => k }; // evita crash
	}
}
